import React from "react";
import styled, { css } from "styled-components";
import { colors } from "../../lib/constant";
import { fontFamily, fontSize, product_sans } from "../../lib/fonts";

const Container = styled.span<{ ghost?: boolean }>`
  background: #fcdbe0;
  border-radius: 9.5px;
  width: 37px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${fontSize("10px")};
  ${fontFamily(product_sans.bold)};
  color: ${colors.primary};

  ${(p) =>
    p.ghost &&
    css`
      background: rgba(255, 255, 255, 0.25);
      color: white;
    `}
`;

export const CapsBeta = ({ ghost }: { ghost?: boolean }) => (
  <Container ghost={ghost}>beta</Container>
);
